import {Component, OnDestroy, OnInit} from '@angular/core';
import {BaseComponent} from "../../base/base.component";
import {
    Country,
    CreateLineGQL,
    CreateProductLineCountryInput,
    CreateProductLineInput, CreateUsefulLinksGQL, CreateUsefulLinksInput,
    GetCountriesByUserGQL,
    GetCountriesByUserQuery,
    GetCountriesGQL,
    GetCountriesQuery,
    ProductLine,
    ProductLinePage,
    RemoveLineGQL, RemoveUsefulLinksGQL,
    SearchProductLine,
    SearchProductLinePageGQL,
    SearchProductLinePageQuery,
    SearchUsefulLinksGQL,
    SearchUsefulLinksInput,
    SearchUsefulLinksQuery,
    SearchUsefulLinksQueryVariables,
    UpdateLineGQL,
    UpdateProductLineInput, UpdateUsefulLinksGQL, UpdateUsefulLinksInput, UsefulLinks, UsefulLinksPage,
    User
} from "../../../generated/graphql";
import {QueryRef} from "apollo-angular";
import {Router} from "@angular/router";
import {NgxSpinnerService} from "ngx-spinner";
import {TranslateService} from "@ngx-translate/core";
import {UserService} from "../../service/user.service";

declare var $: any;

@Component({
    selector: 'app-links',
    templateUrl: './links.component.html',
    styleUrls: ['./links.component.scss']
})
export class LinksComponent extends BaseComponent implements OnInit, OnDestroy {

    user = new User();
    page: UsefulLinksPage = new UsefulLinksPage();
    filter = new SearchUsefulLinksInput();
    searchQuery: QueryRef<SearchUsefulLinksQuery, SearchUsefulLinksQueryVariables>;
    model: UpdateUsefulLinksInput = new UpdateUsefulLinksInput();

    countriesUser: Country[] = [];
    selectedCountries: Country[] = [];
    dropSettings: any = {
        singleSelection: false,
        idField: 'id',
        textField: 'name',
        selectAllText: 'Marcar todos',
        unSelectAllText: 'Desmarcar todos',
        itemsShowLimit: 3,
        allowSearchFilter: true
    };

    constructor(public router: Router,
                public loading: NgxSpinnerService,
                public translate: TranslateService,
                public userService: UserService,
                public getCountriesByUserGQL: GetCountriesByUserGQL,
                public searchGQL: SearchUsefulLinksGQL,
                public createGQL: CreateUsefulLinksGQL,
                public updateGQL: UpdateUsefulLinksGQL,
                public removeGQL: RemoveUsefulLinksGQL,
    ) {
        super(router, loading, translate);
    }

    ngOnInit(): void {
        this.userService.user.subscribe({
            next: data => {
                this.user = data as User;
            }, error: err => super.onError(err)
        });
        this.getSearch();
        this.getCountriesByUser();
    }

    getCountriesByUser() {
        this.getCountriesByUserGQL.watch().valueChanges.subscribe(({data}) => {
            this.countriesUser = data.countriesByUser as Array<Country>;
        });
    }

    ngOnDestroy(): void {
        const elModalAddLine = $('#modalAddLine');
        if (elModalAddLine[0]) {
            elModalAddLine.remove();
        }
    }

    showModal(idModal) {
        $('#' + idModal).modal('show');
    }

    getSearch() {
        this.searchQuery = this.searchGQL.watch({input: this.filter});
        this.searchQuery.valueChanges.subscribe(({data}) => {
            this.page = data.searchUsefulLinks as UsefulLinksPage;
        });
    }

    onFilter() {
        this.searchQuery.refetch({input: this.filter});
    }

    actionNew() {
        this.model = new UpdateProductLineInput();
        this.model.isActive = true;
        this.showModal('modalAddLine');
    }

    actionSave() {
        const arrValidateFields = [
            {value: this.model.name, text: `${this.translate.instant('nome')}<br>`},
            {value: this.model.link, text: `Links <br>`},
            {value: this.selectedCountries, text: `País <br>`},
        ];
        const stringError = this.validateField(arrValidateFields);
        if (!super.isNullOrUndefined(stringError)) {
            this.showMessage(this.translate.instant('baseComponent.warningAttention'), `${this.translate.instant('baseComponent.warningCorrectFields')} <br> ${stringError}`);
            return;
        }

        if (super.isNullOrUndefined(this.model.id)) {
            this.actionCreated();
        } else {
            this.actionUpdate();
        }
    }

    actionEdit(item: UsefulLinks) {
        this.model = new UpdateProductLineInput();
        this.selectedCountries = [];
        item.countries.forEach((e) => {
            this.selectedCountries.push(e);
        });
        Object.assign(this.model, item);
        this.showModal('modalAddLine');
    }

    actionCreated() {
        const data = new CreateUsefulLinksInput();
        data.name = this.model.name;
        data.link = this.model.link;
        data.isActive = this.model.isActive;

        data.countries = [];
        this.selectedCountries.forEach((e) => {
            data.countries.push({id: e.id});
        });
        // data.countries

        this.createGQL.mutate({input: data}).subscribe(() => {
            this.model = new UpdateUsefulLinksInput();
            this.searchQuery.refetch();
            this.closeModal('modalAddLine');
        });


    }

    actionUpdate() {
        const data = new UpdateUsefulLinksInput();
        data.id = this.model.id;
        data.name = this.model.name;
        data.link = this.model.link;
        data.isActive = this.model.isActive;

        data.countries = [];
        this.selectedCountries.forEach((e) => {
            data.countries.push({id: e.id});
        });

        this.updateGQL.mutate({input: data}).subscribe(() => {
            this.model = new UpdateUsefulLinksInput();
            this.searchQuery.refetch();
            this.closeModal('modalAddLine');
        });
    }

    actionDelete(userId) {
        super.confirmMessage(this.translate.instant('baseComponent.warningAttention'), this.translate.instant('baseComponent.warningItemDelete'), () => {
            this.removeGQL.mutate({id: userId}).subscribe((result) => {
                this.searchQuery.refetch();
                super.showMessage(this.translate.instant('baseComponent.success'), this.translate.instant('baseComponent.warningItemDeleteSuccess'), 'success');
            });
        });
    }

    pageChanged(event) {
        this.filter.page = event;
        this.onFilter();
    }

    actionUserProfile() {
        switch (this.user.profile) {
            case 'medical-manager':
                return false;
            case 'district-manager':
                return false;
            case 'analyst-marketing':
                return false;
            case 'product-manager':
                return false;
            case 'marketing-manager':
                return false;
            case 'admin':
                return true;
            case 'admin-local':
                return true;
            case 'consult':
                return false;
        }
    }
}
